export function evaluationTaskPath(runId: string) {
  return `/evaluation-management?run=${encodeURIComponent(runId)}&view=data`
}

export function evaluationTaskUrl(runId: string, origin: string) {
  return new URL(evaluationTaskPath(runId), origin).toString()
}

export const PENDING_EVALUATION_TASK_KEY = 'evaluation-task-after-login'

export function validEvaluationTaskPath(value: string | null): string | null {
  if (!value || !value.startsWith('/evaluation-management?')) return null
  const url = new URL(value, 'https://evaluation.invalid')
  if (url.origin !== 'https://evaluation.invalid' || url.pathname !== '/evaluation-management') return null
  const runId = url.searchParams.get('run')
  if (!runId || runId.length > 200 || !/^[a-zA-Z0-9_-]+$/.test(runId)) return null
  return evaluationTaskPath(runId)
}
